import { Outlet } from 'react-router-dom';
import { Navbar } from '@/components/common/Navbar';
import { Footer } from '@/components/common/Footer';

/**
 * Marketing / public-facing shell.
 * Used for the homepage, product pages, gallery, contact, etc.
 */
export function PublicLayout() {
  return (
    <div className="flex min-h-svh flex-col bg-background">
      <Navbar variant="public" />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
